export const APP_ROUTES = {
  LOGIN: "/",
  DASHBOARD: "/dashboard",
  RFP_UPLOAD: "/rfp-upload-and-parsing",
  UPLOAD_ORG_DOCS: "/upload-docs",
  ORG_MANAGEMENT: "/group-organization-management",
  PERSONNEL_MANAGEMENT: "/personnel-profile-management",
  PREVIOUS_RFP: "/previous-rfp-archive",
  TEMPLATE_LIBRARY: "/template-library",
  PROPOSAL_EDITOR: "/proposal-editor",
  USER_REGISTRATION: "/user-registration",
  CONTENT_RECYCLING: "/content-recycling-assistant",
  MASTERS_MANAGEMENT: "/masters-management",
  ASSIGNED_REQUIREMENTS: "/assigned-requirements",
  ADD_NEW_MEMBER: "add-new-member",
  PROPOSAL_EDITOR_PERMISSION: "proposal-editor",
  ALL_MEMBER_LIST_PERMISSION: "all-members-list-view",
  PRICING: "/pricing",
  ASSIGNED_RFP: "/assigned-rfp",
};
